import styles from './Page.module.scss';

const Page = ({ children }: { children: React.ReactElement }) => (
  <div className={styles.container}>{children}</div>
);

export default Page;
